import { SelectOption } from "../../../packages/ui/form/select/SelectOption.js";
import { SELECTABLE_YEARS } from "../../model/accounting/date/selectableYears.js";

export const YEAR_OPTIONS: SelectOption[] = SELECTABLE_YEARS.map((year) => ({
  value: year.toString(),
  label: year.toString()
}));
